import { PaginatedQueryResult } from '@query/usePaginatedQuery'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Body2, Caption1 } from '@ui/Typography'
import { Table, TableBody, TableCell, TableHeader, TableRow } from '@ui/v2/Table/Table'

import { useWindowResize } from '@utils/domUtils'

import { TradingPoolResultTypeDto } from '@model/RewardsHubDashboardDto'

import { Box } from '@shared/components/Box'

interface Props {
  data: PaginatedQueryResult<TradingPoolResultTypeDto>
  isLoading: boolean
  tradingAccountNames: string[]
  maskAccountName: (value: string) => string
}

export const TradingPoolCampaignLeaderboardTable: React.FC<Props> = ({
  data,
  isLoading,
  tradingAccountNames,
  maskAccountName,
}) => {
  const ownAccountNames = useMemo(() => new Set(tradingAccountNames), [tradingAccountNames])
  const isMobile = useWindowResize()
  const { t } = useTranslation()

  return (
    <Table isLoading={isLoading} noResults={data?.data.length === 0}>
      <TableHeader>
        <TableRow>
          <TableCell>
            <Caption1 medium>{t('RewardsHub.TradingPool.Rank')}</Caption1>
          </TableCell>
          {!isMobile && (
            <TableCell>
              <Caption1 medium>{t('RewardsHub.TradingPool.Trader')}</Caption1>
            </TableCell>
          )}
          <TableCell>
            <Caption1 medium>{t('RewardsHub.TradingPool.Entries')}</Caption1>
          </TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.data.map((row) => {
          const isOwnAccount = ownAccountNames.has(row.account)
          return (
            <TableRow key={row.account}>
              {isMobile ? (
                <TableCell>
                  <Box flex direction={'column'}>
                    <Body2 medium>
                      {isOwnAccount ? row.account : maskAccountName(row.account)}
                    </Body2>
                    <Caption1 color={'text-low-em'}>#{row.rank}</Caption1>
                  </Box>
                </TableCell>
              ) : (
                <>
                  <TableCell>
                    <Body2>#{row.rank}</Body2>
                  </TableCell>
                  <TableCell>{isOwnAccount ? row.account : maskAccountName(row.account)}</TableCell>
                </>
              )}
              <TableCell>{row.entries}</TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
